import { render, staticRenderFns } from "./management-library-policy-category-view.vue?vue&type=template&id=fb1cc8fe&"
import script from "./management-library-policy-category-view.vue?vue&type=script&lang=js&"
export * from "./management-library-policy-category-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports